export interface IOffers {
  /* Предполагается, что id корпуса не может быть установлен, пока не загрузится статистика для него */
  /* То есть не может быть ситуации, что корпус в фильтре выбран, а статистики по нему нет */
  selectedHouseId: number | undefined;
  data: IOffersData;
}

/* Объект, который хранит информацию о статистике предложений по квартирам */
interface IOffersData {
  /* Общая статистика по всем корпусам */
  total: IOffersStats;
  /* Статистика по конкретному корпусу */
  [key: number]: IOffersStats | null;
}

export interface IOffersStats {
  fromAgentsPropsCountDisplay: string;
  fromAgentsPropsCountUrl: string;
  fromDeveloperMaxPrice?: number | null;
  fromDeveloperMinPrice?: number | null;
  fromDeveloperPropsCountDisplay: string;
  fromDeveloperPropsCountUrl: string;
  propsCountDisplay: string;
  propsCountUrl: string;
  fromDeveloperRooms: IFlatOffers[];
}

export interface IFlatOffers {
  roomTypeDisplay: string;
  totalAreaMinDisplay: string;
  fromDeveloperPropsCountDisplay: string;
  fromDeveloperPropsCount: number;
  offersUrl: string;
  price2Range: string;
  layouts: ILayoutData[];
  roomType: ERoomType;
}

export interface ILayoutData {
  offerId: number;
  offerUrl: string;
  roomCount: string;
  finishDate: string;
  totalArea: string;
  priceDisplay: string;
  price?: number;
  layoutImageUrl?: string | null;
  houseName: string;
  gaLabel: string;
}

export enum ERoomType {
  Bed = 'bed',
  FiveRoom = 'fiveRoom',
  FourRoom = 'fourRoom',
  Large = 'large',
  OneRoom = 'oneRoom',
  OpenPlan = 'openPlan',
  Room = 'room',
  Share = 'share',
  Studio = 'studio',
  ThreeRoom = 'threeRoom',
  TwoRoom = 'twoRoom',
}

export enum EOfferTypes {
  ApartmentOnly = 'apartmentOnly',
  BothFlatAndApartment = 'bothFlatAndApartment',
  FlatOnly = 'flatOnly',
}
